import { FC, useState, ReactElement, useEffect } from 'react';
import './style.scss';

interface Props {
  id?: string;
  label: string;
  desc?: any;
  content: ReactElement;
  type?: string;
  vtype?: string;
  contentView?: boolean;
  foldBtn?: boolean;
  foldBtnText?: any;
  foldBtnClickEvent?: (id: string, status: string) => void;
  styleDef?: React.CSSProperties;
}

const TitleContent: FC<Props> = ({
  id = '',
  content,
  label,
  desc,
  styleDef,
  type,
  vtype,
  contentView = true,
  foldBtn,
  foldBtnText = [],
  foldBtnClickEvent,
}) => {
  const [viewState, setViewState] = useState({ active: contentView ? '_active' : '' });
  const viewContent = () => {
    viewState.active === '' ? setViewState({ active: '_active' }) : setViewState({ active: '' });
    if (foldBtnClickEvent) foldBtnClickEvent(id, viewState.active);
  };
  useEffect(() => {
    contentView ? setViewState({ active: '_active' }) : setViewState({ active: '' });
  }, [contentView]);

  return (
    <div className={['_title_content_summary_box_layout', vtype].join(' ')}>
      {label !== '' ? (
        <div className="_label_div">
          <div className="_label _ft_tt_t2">{label}</div>
          {foldBtn ? (
            <div className="_fold">
              {foldBtnText.length > 0 ? (
                <div
                  className={viewState.active === '' ? '_btn_div _text' : '_btn_div _text _d_btn'}
                  onClick={viewContent}
                >
                  <div className="_btn"></div>
                  <div className="_text">
                    {viewState.active === '' ? foldBtnText[0] : foldBtnText[1]}
                  </div>
                </div>
              ) : (
                <div
                  className={viewState.active === '' ? '_btn_div' : '_btn_div _d_btn'}
                  onClick={viewContent}
                >
                  <div className="_btn"></div>
                </div>
              )}
            </div>
          ) : (
            ''
          )}
        </div>
      ) : (
        ''
      )}

      {desc ? <div className="_label_desc">{desc}</div> : ''}
      <div className={['_content_div', viewState.active].join(' ')}>
        <div className={['_content', type, viewState.active].join(' ')} style={styleDef}>
          {content}
        </div>
      </div>
    </div>
  );
};

export default TitleContent;
